import { render, staticRenderFns } from "./RestaurantModal.vue?vue&type=template&id=77d74370&"
import script from "./RestaurantModal.vue?vue&type=script&lang=ts&"
export * from "./RestaurantModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports